import router from "./router"
import store from "./store"
import NProgress from "nprogress" // progress bar
import "nprogress/nprogress.css" // progress bar style
import { Message } from "element-ui"
import { getToken } from "@/utils/auth" // getToken from cookie

NProgress.configure({
  showSpinner: false
}) // NProgress configuration

// const whiteList = ["/login", "/password/reset", "/password/recover"]; // Do not redirect whitelist
const whiteList = [
  /^\/login$/,
  /^\/password\/recover$/,
  /^\/password\/reset(\/[^/]*)?$/
]

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  // Close modal
  // NOTICE: this needs to be done elsewhere later
  store.dispatch("closeModal")

  const hasToken = getToken()

  if (hasToken) {
    if (to.path === "/login") {
      next({
        path: "/"
      })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        next()
      } else {
        try {
          // get user info
          // pharmaflix user has one role so we need to adapt it
          // to the application
          const { role } = await store.dispatch("getInfo")
          const roles = [role]
          const accessRoutes = await store.dispatch(
            "permissions/generateRoutes",
            roles
          )

          router.addRoutes(accessRoutes)

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })
        } catch (err) {
          await store.dispatch("resetToken")
          Message.error(err || "Has Error")
          // next(`/login?redirect=${to.path}`);
          next("/login")
          NProgress.done()
        }
      }
    }
  } else {
    // if (whiteList.indexOf(to.path) !== -1) {
    if (whiteList.some(l => l.test(to.path))) {
      next()
    } else {
      // Otherwise redirect to login page with ?redirect
      // next(`/login?redirect=${to.path}`);
      next(`/login`) //
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
